//new
export class Form {
    name: string;
    widgets: Array<Widget>;
}

export class Widget {
    type: "InputText" | "TextArea" |
        "InputSelect" |
        "HorizontalSelectImage" |
        "VerticalSelectImageBox" |
        "VerticalSelectImage" |
        "HorizontalMultiSelectImage" |
        "VerticalSelectMultiImageBox" |
        "InputTextAddable" |
        "ComboBox" |
        "ComboBoxAddable" |
        "ReadOnlyText" |
        "RadioBox" |
        "Checkbox";
    param: string | ParamForm | Array<any>;
    value: string | Array<ValueForm>;
    values: string | Array<ValueForm>;
    choices: string | Array<ValueForm>;
}

export class ValueForm {
    label: string;
    name: string;
    value: string;
    img: string;
}

export class ParamForm {
    input: string;
    select: string;
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/form.ts